<template>
  <div class="pr-md-24 mt-5 mb-10 sales-invoice">
    <div>
      <v-card class="pa-4 text-left" elevation="0" outlined>
        <div class="d-flex justify-space-between">
          <div>
            <h3 class="font-bold">#{{ saleInvoice.supplierOrderNumber }}</h3>
            <div>
              <p>{{ saleInvoice.supplierOrder.order.shipment.toAddress }}</p>
              <p>{{ saleInvoice.supplierOrder.order.shipment.toCity }}</p>
              <p>{{ saleInvoice.supplierOrder.order.shipment.toState }}</p>
              <p>{{ saleInvoice.supplierOrder.order.shipment.toCountry }}</p>
            </div>
          </div>
          <div>
            <h3 class="font-bold">Issued On</h3>
            <div>
              <p>{{ saleInvoice.createdAt | dateFormat }}</p>
            </div>
            <h3 class="font-bold">Due On</h3>
            <div>
              <p>{{ saleInvoice.createdAt | dateFormat }}</p>
            </div>
          </div>
          <div>
            <h3 class="font-bold">Issued By</h3>
            <div>
              <p>
                Dental Supply LTD<br />
                1 Jameston Road Manchester,<br />
                M1 2JQUnited Kingdom
              </p>
            </div>
          </div>
        </div>
        <div>
          <v-simple-table class="mt-3 elevation-0 black--text">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    <h3 class="font-bold">Name</h3>
                  </th>
                  <th class="text-left">
                    <h3 class="font-bold">Qty</h3>
                  </th>
                  <th>
                    <h3 class="font-bold">Price</h3>
                  </th>
                  <th>
                    <h3 class="font-bold">Total</h3>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in saleInvoice.supplierOrder.items"
                  :key="item.name"
                >
                  <td>{{ item.name }}</td>
                  <td>{{ item.quantity }}</td>
                  <td>{{ item.currency | currencySymbol }}{{ item.amountPerItem }}</td>
                  <td>{{ item.amount }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
        <div class="d-flex justify-end mt-12">
          <div class="w-60">
            <div class="text-left d-flex justify-start pl-10">
              <invoice-materials />
            </div>
          </div>
          <div class="flex">
            <div class="mt-4">
              <div class="d-flex">
                <div class="w-30 mr-14">
                  <h3 class="font-bold">Sub Total:</h3>
                </div>
                <div class="">
                  <h3 class="font-bold">{{ saleInvoice.currency | currencySymbol }}{{ saleInvoice.subTotal }}</h3>
                </div>
              </div>
            </div>
            <div class="mt-4">
              <div class="d-flex">
                <div class="w-30 mr-14">
                  <h3 class="font-bold">VAT:</h3>
                </div>
                <div class="">
                  <h3 class="font-bold">{{ saleInvoice.currency | currencySymbol }}{{ saleInvoice.vat }}</h3>
                </div>
              </div>
            </div>
            <div class="mt-4">
              <div class="d-flex">
                <div class="w-30 mr-14">
                  <h3 class="font-bold">Total:</h3>
                </div>
                <div class="">
                  <h3 class="font-bold">{{ saleInvoice.currency | currencySymbol }}{{ saleInvoice.total }}</h3>
                </div>
              </div>
            </div>
            <div class="mt-10" v-if="saleInvoice.paid">
              <invoice-logo></invoice-logo>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import moment from "moment";
import InvoiceLogo from "@/components/animations/Invoice.vue";
import InvoiceMaterials from "@/components/animations/InvoiceMaterials.vue";
export default {
  props: ["id"],
  mounted() {
    this.$store.dispatch("finance/LOAD_SALES_INVOICE", this.id);
  },
  components: {
    InvoiceLogo,
    InvoiceMaterials
  },
  computed: {
    ...mapState({
      saleInvoice: state => state.finance.saleInvoice
    })
  },
  filters: {
    dateFormat(val) {
      return moment(val).format("DD MMMM, YYYY");
    },

    currencySymbol: function(value) {
      let symbols = {
        USD: "$", // US Dollar
        EUR: "€", // Euro
        CRC: "₡", // Costa Rican Colón
        GBP: "£", // British Pound Sterling
        ILS: "₪", // Israeli New Sheqel
        INR: "₹", // Indian Rupee
        JPY: "¥", // Japanese Yen
        KRW: "₩", // South Korean Won
        NGN: "₦", // Nigerian Naira
        PHP: "₱", // Philippine Peso
        PLN: "zł", // Polish Zloty
        PYG: "₲", // Paraguayan Guarani
        THB: "฿", // Thai Baht
        UAH: "₴", // Ukrainian Hryvnia
        VND: "₫" // Vietnamese Dong
      };
      return symbols[value];
    }
  }
};
</script>
<style lang="scss" scoped>
.sales-invoice {
  h3 {
    font-family: "Gotham-Book";
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 30px;
  }
  p {
    font-family: "Gotham-Book";
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 21px;
    margin-bottom: 1px;
  }
}
</style>
<style lang="scss">
.sales-invoice {
  table {
    border: 1px solid #d7d5d5;
    thead {
      background: none !important;
    }
  }
}
</style>
